<template>
  <c-notification
    v-if="error"
    title="Fehler beim Laden"
    description="Beim Lesen der Datenbank ist leider ein Fehler aufgetreten. Bitte versuchen Sie später die Seite neu zu laden."
    type="error"
  />

  <div
    v-else
    id="table"
  >
    <div class="row">
      <div
        v-for="(filter, index) in filters"
        :key="index"
        class="col-md-6 col-lg-4"
      >
        <c-filter
          :id="`table-filter-${index}`"
          v-model="filter.value"
          :label="filter.name"
          :options="filter.options"
          :color="color"
        />
      </div>
    </div>

    <c-search
      v-if="search"
      id="table-search"
      v-model="search.value"
      :color="color"
    />

    <c-table
      v-if="filteredBody.length"
      :head="filteredHead"
      :body="filteredBody"
      :color="color"
      :sort-column="sort.column"
      :sort-dir="sort.dir"
      @sort="handleSort"
    />

    <c-notification
      v-else
      title="Keine Daten gefunden"
      description="Leider konnten zu Ihrer Filterung keine passenden Daten gefunden werden. Bitte versuchen Sie andere Einstellungen."
      type="warning"
    />
  </div>
</template>

<script>
import CFilter from './components/CFilter.vue'
import CNotification from '../../../vue/components/CNotification.vue'
import CSearch from './components/CSearch.vue'
import CTable from './components/CTable.vue'

export default {
  name: 'App',

  components: {
    CFilter,
    CNotification,
    CSearch,
    CTable
  },

  data () {
    return {
      error: false,
      color: undefined,
      search: false,
      filters: [],
      sort: {
        column: undefined,
        dir: 'asc'
      },
      table: {
        head: [],
        body: []
      }
    }
  },

  computed: {
    filteredHead () {
      return this.table.head
        // Remove hidden cells
        .filter(cell => !cell.hidden)
    },
    filteredBody () {
      return this.table.body
        // Search
        .filter(row => {
          if (!this.search || !this.search.value) {
            return true
          }

          return row[this.search.column].content.toLowerCase().includes(this.search.value)
        })
        // Filters
        .filter(row => this.filters.every(filter => {
          if (!filter.value) {
            return true
          }

          return filter.value === row[filter.column].content
        }))
        // Remove hidden cells
        .map(row => row.filter(cell => !cell.hidden))
        // Sort rows
        .sort((a, b) => {
          if (typeof this.sort.column !== 'number') {
            return 0
          }

          const aCell = a[this.sort.column].sort ||
            a[this.sort.column].content.toString().toLowerCase()

          const bCell = b[this.sort.column].sort ||
            b[this.sort.column].content.toString().toLowerCase()

          if (this.sort.dir === 'asc') {
            if (aCell > bCell) {
              return 1
            } else if (aCell < bCell) {
              return -1
            }
          } else if (this.sort.dir === 'desc') {
            if (aCell > bCell) {
              return -1
            } else if (aCell < bCell) {
              return 1
            }
          }

          return 0
        })
    }
  },

  created () {
    const raw = document.querySelector('#table-filter-data').textContent.trim()

    if (!raw) {
      this.error = true
      return
    }

    try {
      const data = JSON.parse(raw)

      this.color = data.color
      this.search = data.search
      this.filters = data.filters
      this.table.head = data.table.head
      this.table.body = data.table.body
    } catch (error) {
      this.error = true
    }
  },

  methods: {
    handleSort ({ column, dir }) {
      this.sort.column = column
      this.sort.dir = dir
    }
  }
}
</script>
